export default {
  async fetchCountOrderForAcceptance({ commit }) {
    try {
      const { count } = await this.$axios.$get(
        `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/count-order-for-acceptance`,
      );
      commit('changeCountOrderForAcceptance', count);
    } catch {}
  },
  async fetchOtherAccounts({ state, commit }) {
    try {
      const { accounts } = await this.$axios.$get(
        `${this.$config.baseOfixApi}/e-commerce/v1/account-switcher`,
      );
      commit('setCurrentCompany', state.user.id);
      commit('setOtherAccounts', accounts);
    } catch {}
  },
  async checkAccountSwitch({ state, commit, dispatch }, userId) {
    if (state.currentCompany !== userId && userId) {
      // commit('setCurrentCompany', userId);
      try {
        const { message, isDecisionNeeded, moveCartOptions, accountFromInfo, accountToInfo } =
          await this.$axios.$get(
            `${this.$config.baseOfixApi}/e-commerce/v1/account-switcher/${userId}`,
          );

        if (!isDecisionNeeded) {
          dispatch('switchAccount', { userId, decision: 'nothing' });
        } else {
          await commit(
            'modal/pushModal',
            {
              modal: {
                name: 'switchAccountDecision',
                path: 'SwitchAccount/ModalSwitchAccountDecision',
                title: 'Twój koszyk zawiera produkty',
                footerDisabled: true,
              },
              data: { message, isDecisionNeeded, moveCartOptions, accountFromInfo, accountToInfo },
            },
            { root: true },
          );
        }
      } catch {}
    }
  },
  async switchAccount({ state, commit }, { userId, decision }) {
    await this.$axios.$post(
      `${this.$config.baseOfixApi}/e-commerce/v1/account-switcher/${userId}`,
      {
        userDecisionWhatToDoWithShoppingCarts: decision,
      },
    );
    window.location.reload();
  },
};
